import { Injectable } from '@angular/core';

import { CacheService } from 'src/app/services/core/cache.service';

@Injectable({
    providedIn: 'root'
})
export class SidebarService {

    cards: any = {
        ai: { open: false },
        attributes: { open: true },
        connections: { open: true },
        cta: { open: false },
        distribution: { open: true },
        files: { open: true },
        filters: { open: true },
        folders: { open: true },
        general: { open: true },
        information: { open: true },
        inputMode: { open: true },
        lookAndFeel: { open: false }, // duplicate
        look_and_feel: { open: false }, // duplicate
        media: { open: true },
        multilingual: { open: false },
        music: { open: false },
        overlay: { open: true },
        output: { open: true },
        parameters: { open: true },
        platforms: { open: true },
        source: { open: true },
        sources: { open: true },
        styles: { open: false },
        tags: { open: true },
        templates: { open: false },
        types: { open: true },
        visualSpeaker: { open: false },
        voiceover: { open: false },
    };

    constructor(
        private cache: CacheService,
    ) {

    }

    getCacheKey(page: string | null = 'all') {
        return `pipeline_sidebar_cards_${page || 'all'}`;
    }

    async getCards(page: string | null = 'all') {
        page = page || 'all';

        const cacheKey: string = this.getCacheKey(page);
        const fromCache: any = await this.cache.get(cacheKey, -1);

        return (!!fromCache && !!fromCache.data ? fromCache.data : this.cards);
    }

    async setCards(cards: any, page: string | null = 'all') {
        page = page || 'all';

        // load config from cache
        let cachedConfig: any = (await this.getCards() || {});

        const cardUpdateKeys: string[] = Object.keys(cards);

        // append updated values to config
        if (!!cardUpdateKeys && !!cardUpdateKeys.length) {
            cardUpdateKeys.forEach((key: string) => {
                if (!cachedConfig.hasOwnProperty(key)) {
                    cachedConfig[key] = {};
                }
                cachedConfig[key] = Object.assign(cachedConfig[key], cards[key]);
            });
        }

        // update cache storage (@todo: sync server-side)
        return this.cache.set(this.getCacheKey(page), cachedConfig);
    }

}